import { render } from "./tabgroup.presentational.vue?vue&type=template&id=3ba47c02"
import script from "./tabgroup.presentational.vue?vue&type=script&lang=js"
export * from "./tabgroup.presentational.vue?vue&type=script&lang=js"

import "./tabgroup.presentational.vue?vue&type=style&index=0&id=3ba47c02&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__